<template>
  <div v-loading="loading" v-html="content" class="blog-post ql-editor" ></div>
</template>

<script>
import {api} from 'macarons'

export default {
  data () {
    return {
      loading: true,
      content: null
    }
  },
  created () {
    api.get('/home').then(({data}) => {
      this.loading = false
      this.content = data.content
    }).catch(() => {
      this.content = 'Merci de remplir les filtres afin d\'accèder à cette page'
    })
  }
}
</script>

<style scoped>
.blog-post >>> img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/macarons/components/NoAccess.vue